// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import agentReducer from "./agentSlice";
import userReducer from "./userSlice";
import provisionReducer from "./provisionSlice";
import errorReducer from "./errorSlice";
export const store = configureStore({
  reducer: {
    agent: agentReducer,
    user: userReducer,
    provision: provisionReducer,
    error: errorReducer,
  },
});
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
